import React from "react";

interface CrossIconProps extends React.SVGProps<SVGSVGElement> {}

const CrossIcon: React.FC<CrossIconProps> = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props} // ← اینجا props را به svg منتقل می‌کنیم
  >
    {/* Vertical bar */}
    <rect
      x="12"
      y="4"
      width="4"
      height="20"
      rx="1"
      fill="currentColor"
    />
    {/* Horizontal bar */}
    <rect
      x="6"
      y="9"
      width="16"
      height="4"
      rx="1"
      fill="currentColor"
    />
  </svg>
);

export default CrossIcon;










// const CrossIcon = () => (
//     <svg
//         width="28"
//         height="28"
//         viewBox="0 0 28 28"
//         fill="none"
//         xmlns="http://www.w3.org/2000/svg"
//     >
//         {/* Vertical bar */}
//         <rect
//             x="12"
//             y="4"
//             width="4"
//             height="20"
//             rx="1"
//             fill="currentColor"
//         />
//         {/* Horizontal bar (closer to top) */}
//         <rect
//             x="6"
//             y="9"
//             width="16"
//             height="4"
//             rx="1"
//             fill="currentColor"
//         />
//     </svg>
// );

// export default CrossIcon;